<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Hồ sơ xe"
          :link="[
            {
              text: 'Hồ sơ xe',
              href: 'bus-manager'
            }
          ]"
        />
      </div>
      <div>
        <v-btn @click="() => $refs['dialog-bus-info'].openDialog('create')" class="ml-6" depressed color="primary">
          THÊM HỒ SƠ XE
        </v-btn>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title
                class="primary--text"
                style="cursor: pointer"
                @click="() => $refs['dialog-import-excel'].openDialog()"
                >NHẬP EXCEL</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <BusManagerFilter />
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <ListBusInfo />
    </v-card>
    <DialogBusInfo ref="dialog-bus-info" />
    <DialogImportExcel ref="dialog-import-excel" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import BusManagerFilter from '@/modules/bus/bus-manager/BusManagerFilter.vue'
import ListBusInfo from '@/modules/bus/bus-manager/ListBusInfo.vue'
import DialogBusInfo from '@/modules/bus/bus-manager/DialogBusInfo.vue'
import DialogImportExcel from '@/modules/bus/bus-manager/DialogImportExcel.vue'

export default {
  components: {
    Breadcrumbs,
    ListBusInfo,
    DialogBusInfo,
    DialogImportExcel,
    BusManagerFilter
  },
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {}
}
</script>
<style scoped></style>
